export class RestoreEc2InstanceConfig {
    'instanceType';
    'subnetId';
    'securityGroupIds';
    'instanceProfileName';
    'tags';
    'volumeRestoreParameters';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceType",
            "baseName": "instanceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetId",
            "baseName": "subnetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "instanceProfileName",
            "baseName": "instanceProfileName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeRestoreParameters",
            "baseName": "volumeRestoreParameters",
            "type": "Array<RestoreInstanceVolumeInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreEc2InstanceConfig.attributeTypeMap;
    }
    constructor() {
    }
}
